<template>
  <sTooltip
    :border="false"
    :content="text"
    :data-qa="data_qa"
    placement="bottom"
    type="white">
    <sIcon
      :color="color"
      size="12"
      :type="icon"/>
  </sTooltip>
</template>

<script>
export default {
  name: 'verificationStatus',
  props: {
    status: String
  },
  computed: {
    icon() {
      return this.status == 'RECOMENDED' ? 'accept' : 'info'
    },
    color() {
      return this.status == 'RECOMENDED' ? 'var(--v-green_chosen-base)' : 'var(--v-secondary__red-base)'
    },
    text() {
      return this.status == 'RECOMENDED' ? this.$t('Suppliers.RecommendedForCoperation') : this.$t('Suppliers.NotRecommendedForCoperation')
    },
    data_qa() {
      return (this.status == 'RECOMENDED' ? '' : 'not-') + 'recomended'
    },
  }
}
</script>
